import { render, staticRenderFns } from "./UserGroupPage.vue?vue&type=template&id=12754916&scoped=true&lang=html&"
import script from "./UserGroupPage.vue?vue&type=script&lang=js&"
export * from "./UserGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupPage.vue?vue&type=style&index=0&id=12754916&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12754916",
  null
  
)

export default component.exports